import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { SellersVtexListComp } from 'pages/logistica/sellers-vetex/components';
import { SellersVtexProvider } from 'pages/logistica/sellers-vetex/contexts';

export function SellersVtexList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['LOGISTICA_SELLER_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <SellersVtexProvider>
                <SellersVtexListComp />
            </SellersVtexProvider>
        </ListagemProvider>
    );
}
